(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-product-feature"] && !Shopify.designMode) return;
  try {
    
/* Custom elements initialize again after Theme Editor section replacement. */
(() => {
  if (customElements.get('mh-product-feature')) return;
  customElements.define('mh-product-feature', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.priceObserver?.disconnect();
      this.observedPriceRoot = null;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.index = 0;
      this.form = this.querySelector('.mhpf__form');
      this.button = this.querySelector('[data-submit]');
      this.variant = this.querySelector('[data-variant]');
      this.busy = false;
      this.addEventListener('click', event => {
        const close = event.target.closest('[data-safety-close]');
        if (close) { const details = close.closest('[data-safety]'); details.open = false; details.querySelector('summary').focus(); }
        const thumb = event.target.closest('[data-thumb]');
        const step = event.target.closest('[data-gallery-step]');
        const videoStep = event.target.closest('[data-video-step]');
        if (thumb) this.go(Number(thumb.dataset.thumb));
        if (step) this.go(this.index + Number(step.dataset.galleryStep));
        if (videoStep) {
          const rail = this.querySelector('[data-videos]');
          rail?.scrollBy({left:rail.clientWidth * Number(videoStep.dataset.videoStep),behavior:this.motion()});
        }
      }, {signal});

      this.querySelectorAll('[data-safety]').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          details.dataset.placement = 'above';
          const panel = details.querySelector('[data-safety-popup]');
          if (panel.getBoundingClientRect().top < 12) details.dataset.placement = 'below';
        }, {signal});
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        this.querySelectorAll('[data-safety][open]').forEach(details => {
          details.open = false;
          details.querySelector('summary').focus();
        });
      }, {signal});
      document.addEventListener('pointerdown', event => {
        this.querySelectorAll('[data-safety][open]').forEach(details => {
          if (!details.contains(event.target)) details.open = false;
        });
      }, {signal});
      this.updateDelivery();
      clearInterval(this.deliveryTimer);
      if (this.querySelector('[data-delivery]')) this.deliveryTimer = setInterval(() => {
        if (!document.hidden) this.updateDelivery();
      }, 60000);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.updateDelivery();
      }, {signal});
      this.track?.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, {signal});
      this.track?.addEventListener('scroll', () => {
        const width = this.track.clientWidth;
        if (!width) return;
        this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
        this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === this.index)));
      }, {signal, passive:true});
      this.variant?.addEventListener('change', () => this.updateVariant(true), {signal});
      this.form?.querySelector('[data-native-quantity]')?.addEventListener('input', () => this.updateButtonPrices(), {signal});
      this.form?.addEventListener('submit', event => this.submit(event), {signal});
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        if (slide) this.go(this.slides.indexOf(slide));
        const details = event.target.closest('details') || event.target.querySelector('[data-safety]');
        if (details) details.open = true;
      }, {signal});
      window.addEventListener('pageshow', () => { this.busy = false; this.button?.removeAttribute('aria-busy'); this.updateVariant(false); this.updateDelivery(); }, {signal});
      this.updateVariant(false);
      const widget = this.querySelector('kaching-bundle');
      const preview = this.querySelector('[data-app-preview]');
      if (widget) {
        const sync = () => {
          if (preview) preview.hidden = this.widgetReady();
          this.updateButtonPrices();
        };
        this.observer?.disconnect();
        this.observer = new MutationObserver(sync);
        this.observer.observe(widget, {childList:true, subtree:true, attributes:true, characterData:true});
        ['deal-bar-selected', 'variant-selected', 'variants-changed', 'items-changed', 'kaching-bundles-block-loaded', 'change'].forEach(name => {
          widget.addEventListener(name, () => queueMicrotask(sync), {signal, capture:true});
        });
        customElements.whenDefined('kaching-bundles-block').then(() => {
          if (!signal.aborted && this.isConnected) sync();
        });
        sync();
      }
    }

    updateDelivery(now = new Date()) {
      const widget = this.querySelector('[data-delivery]');
      if (!widget) return;
      const data = widget.dataset;
      const fallback = widget.querySelector('[data-delivery-fallback]');
      const result = widget.querySelector('[data-delivery-result]');
      const dateText = widget.querySelector('[data-delivery-date]');
      const flag = (element, code) => {
        if (element.dataset.renderedFlag === code) return;
        element.replaceChildren();
        element.dataset.renderedFlag = code;
        if (!/^[A-Z]{2}$/.test(code)) return;
        const image = document.createElement('img');
        image.width = 16; image.height = 12; image.alt = ''; image.loading = 'lazy';
        image.addEventListener('error', () => { image.hidden = true; }, {once:true});
        image.src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg';
        element.append(image);
      };
      widget.querySelectorAll('[data-country-flag]').forEach(el => flag(el, el.dataset.countryFlag));
      result.hidden = true;
      fallback.hidden = false;
      widget.hidden = data.hideUnmatched === 'true' && this.dataset.editor !== 'true';
      const rules = [...widget.querySelectorAll('[data-delivery-rule]')].filter(el => el.dataset.enabled === 'true');
      const codes = rule => rule.dataset.countries.toUpperCase().split(/[\s,;]+/).filter(Boolean);
      const country = (data.country || '').toUpperCase();
      const rule = rules.find(el => country && codes(el).includes(country)) || rules.find(el => codes(el).includes('*'));
      const origin = (rule?.dataset.origin || data.origin || '').trim().toUpperCase();
      widget.querySelector('[data-origin-line]').hidden = !/^[A-Z]{2}$/.test(origin);
      widget.querySelector('[data-origin-code]').textContent = origin;
      flag(widget.querySelector('[data-origin-flag]'), origin);
      if (!rule) return;
      try {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:data.timezone || 'UTC', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', hourCycle:'h23'}).formatToParts(now).map(part => [part.type, part.value]));
        const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
        const settings = rule.dataset;
        const iso = date => date.toISOString().slice(0,10);
        const parseDate = value => {
          if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) throw new Error('Invalid date');
          const date = new Date(value + 'T00:00:00Z');
          if (!Number.isFinite(date.getTime()) || iso(date) !== value) throw new Error('Invalid date');
          return date;
        };
        let first, last;
        if (settings.mode === 'fixed') {
          last = parseDate(settings.end);
          first = settings.start ? parseDate(settings.start) : new Date(last);
          if (last < today || first > last) return;
          if (first < today) first = new Date(today);
        } else {
          const excluded = new Set((data.holidays || '').split(/[\s,;]+/).filter(Boolean));
          const eligible = date => !excluded.has(iso(date)) && (settings.days !== 'business' || (date.getUTCDay() !== 0 && date.getUTCDay() !== 6));
          const next = date => date.setUTCDate(date.getUTCDate() + 1);
          const base = new Date(today);
          const cutoff = Number(data.cutoff);
          if (cutoff < 24 && Number(parts.hour) >= cutoff) next(base);
          let attempts = 0;
          while (!eligible(base)) { next(base); if (++attempts > 730) throw new Error('No eligible day'); }
          const addDays = days => {
            const date = new Date(base);
            let remaining = Math.max(0, Math.min(90, days));
            let loops = 0;
            while (remaining > 0) {
              next(date);
              if (eligible(date)) remaining--;
              if (++loops > 730) throw new Error('No eligible day');
            }
            return date;
          };
          const minimum = Number(settings.min);
          const maximum = Math.max(minimum, Number(settings.max));
          if (!Number.isFinite(minimum) || !Number.isFinite(maximum)) return;
          first = addDays(minimum);
          last = addDays(maximum);
        }
        const formats = {
          weekday:{weekday:'short',month:'short',day:'numeric'},
          short:{month:'short',day:'numeric'},
          long:{month:'long',day:'numeric',year:'numeric'},
          numeric:{year:'numeric',month:'2-digit',day:'2-digit'}
        };
        const options = {...(formats[data.dateStyle] || formats.weekday),timeZone:'UTC'};
        let formatter;
        try { formatter = new Intl.DateTimeFormat(data.locale || document.documentElement.lang || 'en', options); }
        catch { formatter = new Intl.DateTimeFormat('en', options); }
        const text = settings.mode === 'latest' || iso(first) === iso(last) ? formatter.format(last) : formatter.format(first) + ' – ' + formatter.format(last);
        if (dateText.textContent !== text) dateText.textContent = text;
        result.hidden = false;
        fallback.hidden = true;
        widget.hidden = false;
      } catch {
        result.hidden = true;
        fallback.hidden = false;
      }
    }
    motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    go(index) {
      if (!this.track || !this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({left:this.track.clientWidth * this.index,behavior:this.motion()});
      const thumb = this.thumbs[this.index];
      if (thumb) {
        const rail = thumb.parentElement;
        rail.scrollTo({left:thumb.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft,behavior:this.motion()});
      }
    }
    updateVariant(updateUrl) {
      if (!this.variant || !this.button) return;
      const option = this.variant.selectedOptions?.[0] || this.variant;
      const available = option.dataset.available === 'true';
      const blocked = this.dataset.blocked === 'true';
      this.button.disabled = !available || blocked || this.busy;
      const label = this.button.querySelector('[data-button-text]');
      if (!blocked && !this.busy) label.textContent = available ? this.button.dataset.addLabel : this.button.dataset.soldLabel;
      const price = this.querySelector('[data-price-display]');
      const compare = this.querySelector('[data-compare-display]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare && 'compare' in option.dataset) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
      const quantity = this.form.querySelector('[data-native-quantity]');
      if (quantity && option.dataset.min) {
        quantity.min = option.dataset.min;
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        if (!quantity.checkValidity()) quantity.value = quantity.min;
      }
      if (updateUrl) {
        const url = new URL(window.location.href); url.searchParams.set('variant', this.variant.value); history.replaceState({}, '', url);
      }
      if (updateUrl || !this.initialMediaSelected) {
        const imageIndex = this.slides.findIndex(slide => slide.dataset.imageId && slide.dataset.imageId === option.dataset.image);
        if (imageIndex >= 0) this.go(imageIndex);
        this.initialMediaSelected = true;
      }
      this.updateButtonPrices();
    }
    money(cents) {
      if (this.dataset.currency && this.dataset.currency !== this.dataset.baseCurrency) {
        try { return new Intl.NumberFormat(this.dataset.language || 'en', {style:'currency',currency:this.dataset.currency}).format(cents / 100); }
        catch { return ''; }
      }
      const format = this.dataset.moneyFormat || '';
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const formats = {
        amount:[2,',','.'], amount_no_decimals:[0,',','.'],
        amount_with_comma_separator:[2,'.',','], amount_no_decimals_with_comma_separator:[0,'.',','],
        amount_with_apostrophe_separator:[2,"'",'.'], amount_with_space_separator:[2,' ', ','],
        amount_with_period_and_space_separator:[2,' ','.'], amount_with_space_and_comma_separator:[2,' ', ','],
        amount_no_decimals_with_space_separator:[0,' ','.']
      };
      if (!match || !formats[match[1]]) return '';
      const [precision, thousands, decimal] = formats[match[1]];
      const parts = (cents / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const html = format.replace(match[0], parts.join(decimal));
      return new DOMParser().parseFromString(html, 'text/html').body.textContent;
    }
    updateButtonPrices() {
      const badge = this.querySelector('[data-button-prices]');
      if (!badge || !this.variant) return;
      const option = this.variant.selectedOptions?.[0] || this.variant;
      let price = '', compare = '';
      if (!this.busy && option.dataset.available === 'true' && this.dataset.blocked !== 'true') {
        if (this.dataset.mode === 'bundle') {
          const widget = this.querySelector('kaching-bundle');
          const host = widget?.querySelector('kaching-bundles-block') || widget?.shadowRoot?.querySelector('kaching-bundles-block');
          const root = host?.shadowRoot || widget?.shadowRoot || widget;
          const read = value => {
            if (typeof value?.formatted !== 'string') return '';
            return new DOMParser().parseFromString(value.formatted, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
          };
          try {
            const pricing = typeof host?.pricing === 'function' ? host.pricing() : null;
            price = read(pricing?.discountedPrice);
            if (price && typeof pricing?.discountedPrice?.amount === 'number' && typeof pricing?.fullPrice?.amount === 'number' && pricing.fullPrice.amount > pricing.discountedPrice.amount) {
              compare = read(pricing.fullPrice);
            }
          } catch {
            price = '';
            compare = '';
          }
          if (root?.host && this.observedPriceRoot !== root) {
            this.priceObserver?.disconnect();
            this.observedPriceRoot = root;
            this.priceObserver = new MutationObserver(() => this.updateButtonPrices());
            this.priceObserver.observe(root, {childList:true, subtree:true, attributes:true, characterData:true});
          }
        } else {
          const input = this.form.querySelector('[data-native-quantity]');
          const quantity = badge.dataset.quantityTotal === 'true' ? Number(input?.value || 1) : 1;
          const cents = Number(option.dataset.priceCents), compareCents = Number(option.dataset.compareCents);
          if ((!input || input.checkValidity()) && Number.isInteger(quantity) && quantity > 0 && Number.isFinite(cents)) {
            price = quantity === 1 ? new DOMParser().parseFromString(option.dataset.price || '', 'text/html').body.textContent : this.money(cents * quantity);
            if (compareCents > cents) compare = quantity === 1 ? new DOMParser().parseFromString(option.dataset.compare || '', 'text/html').body.textContent : this.money(compareCents * quantity);
          }
        }
      }
      const showPrice = badge.dataset.showPrice === 'true' && Boolean(price);
      const showCompare = badge.dataset.showCompare === 'true' && Boolean(compare);
      const priceNode = badge.querySelector('[data-button-price]');
      const compareNode = badge.querySelector('[data-button-compare]');
      if (priceNode.textContent !== price) priceNode.textContent = price;
      if (compareNode.textContent !== compare) compareNode.textContent = compare;
      badge.querySelector('[data-button-price-wrap]').hidden = !showPrice;
      badge.querySelector('[data-button-compare-wrap]').hidden = !showCompare;
      badge.hidden = !showPrice && !showCompare;
    }
    widgetReady() {
      const widget = this.querySelector('kaching-bundle');
      if (!widget || widget.getAttribute('aria-busy') === 'true') return false;
      const box = widget.getBoundingClientRect();
      return box.width > 0 && box.height > 5 && Boolean((widget.shadowRoot || widget).querySelector('input:not([type="hidden"]),select,button,[role="radio"],[role="checkbox"]'));
    }
    showError(message) { const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; }
    async submit(event) {
      if (event.defaultPrevented) return;
      if (this.busy || this.button.disabled || this.dataset.blocked === 'true') { event.preventDefault(); return; }
      if (this.dataset.mode === 'bundle') {
        if (!this.widgetReady()) { event.preventDefault(); this.showError(this.button.dataset.widgetError); return; }
      }
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      this.busy = true; this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.querySelector('[data-button-text]').textContent = this.button.dataset.loadingLabel;
      this.querySelector('[data-error]').hidden = true;
      this.updateButtonPrices();
      const destination = this.dataset.afterAdd;
      const drawer = destination === 'drawer' ? document.querySelector('cart-drawer') : null;
      const drawerReady = drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
      const formData = new FormData(this.form);
      if (drawerReady) {
        formData.set('sections', drawer.getSectionsToRender().map(section => section.id).slice(0,5).join(','));
        formData.set('sections_url', window.location.pathname);
        drawer.setActiveElement?.(this.button);
      }
      let result;
      try {
        /* Keep the real form and normal Ajax request so Kaching can supply its bundle items and selling plans. */
        const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{Accept:'application/json', 'X-Requested-With':'XMLHttpRequest'}, body:formData, signal:this.abort.signal});
        result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.button.dataset.networkError);
      } catch (error) {
        if (!this.isConnected) return;
        this.showError(error instanceof TypeError || error.name === 'SyntaxError' ? this.button.dataset.networkError : error.message);
        this.busy = false; this.button.removeAttribute('aria-busy'); this.updateVariant(false);
        return;
      }
      /* From this point the item is added: a drawer failure must never repeat the POST. */
      if (destination === 'checkout') { window.location.assign(this.dataset.checkoutUrl); return; }
      if (drawerReady) {
        try {
          const sections = drawer.getSectionsToRender();
          const valid = sections.length && sections.every(section => {
            const html = result.sections?.[section.id];
            return typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
          });
          if (!valid) throw new Error('Cart sections unavailable');
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
          this.busy = false; this.button.removeAttribute('aria-busy'); this.updateVariant(false);
          return;
        } catch (_) { /* The cart page is a safe fallback after a successful add. */ }
      }
      window.location.assign(this.dataset.cartUrl);
    }
    disconnectedCallback() { clearInterval(this.deliveryTimer); this.abort?.abort(); this.observer?.disconnect(); this.priceObserver?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
